import React, { useState, useEffect } from 'react';
import { isEmpty, isNil } from 'lodash';
import moment from 'moment';
import { collectSegmentsFromProviders, isUnixTimestamp } from '../../../../utils/campaigns';

const DisplayTabChartsController = ({
  children,
  url,
  expiresAt,
  refetch,
  dataCampaignRangeDate,
  setDataCampaignRangeDate,
  byCampaignRangeDate,
  setByCampaignRangeDate,
  chartData,
  setChartData,
  providersTab,
  providerIndex,
  campaignOrder,
  hasInsights,
  userPermission,
  setPastReportId,
  setUsePastReportId,
  displayReportsConnection,
  currentReportId,
  setPastReportIdx,
  pastReportIdx,
  usePastReportId,
  ...props
}) => {
  const [rawData, setRawData] = useState(null);
  const [loadingRawData, setLoadingRawData] = useState(true);
  const [isValidUrl, setIsValidUrl] = useState(null);
  const [s3Url, setS3Url] = useState(null);
  const [displayData, setDisplayData] = useState(null);
  const [selectedSegmentsDimension, setSegmentsDimension] = useState('ais');
  const [permission, setPermission] = useState(userPermission);

  const chartDataProvider = chartData && chartData.byProvider;
  const getLiquidMVideoLogs =
    chartData &&
    chartData.byProvider &&
    chartData.byProvider.liquid &&
    chartData.byProvider.liquidm.videoLogs;

  // VideoLogs
  let byProvider = chartDataProvider ? getLiquidMVideoLogs : [];

  const handleSelectPastReport = (idx) => {
    setPastReportIdx(idx);
  };

  const handleAfterChangePastReport = () => {
    setPastReportId(
      displayReportsConnection.campaignReportsConnection.edges[pastReportIdx - 1].node.id
    );
    setUsePastReportId(true);
  };

  const handleUseDefaultReportId = () => {
    setUsePastReportId(false);
    setPastReportIdx(1);
    refetch(currentReportId);
  };

  //Time check happens first

  useEffect(() => {
    const currentTime = new Date().toUTCString();
    if (currentTime <= expiresAt) {
      //url is valid - set url
      setS3Url(url);
      setIsValidUrl(true);
    } else {
      //url is valid - refetch
      setIsValidUrl(false);
      refetch();
      setS3Url(null);
    }
  }, [expiresAt, s3Url, setS3Url, refetch, url]);

  useEffect(() => {
    if (!isNil(userPermission)) {
      setPermission(userPermission);
    }
  }, [userPermission]);

  //If check happens - we have a url (from reload or first load)
  useEffect(() => {
    if (s3Url && loadingRawData)
      fetch(s3Url).then(async (response) => {
        if (response) {
          try {
            await response.json().then((json) => {
              setRawData(json);
              setLoadingRawData(false);
            });
          } catch (err) {
            setLoadingRawData(false);
          }
        }
      });
  }, [s3Url, loadingRawData]);

  useEffect(() => {
    if (rawData && !chartData.byDate && campaignOrder.version >= 1.3) {
      let all, data, displayReports;
      if (rawData.displayReports) {
        const { byProvider, byDate, byDay, creatives, deviceType, publishers, chartsBuilt } =
          rawData;
        displayReports = rawData.displayReports;
        const providerAll = !isEmpty(byProvider) ? Object.entries(byProvider)[0][1] : null;
        all = {
          byDate,
          byDay,
          creatives,
          deviceType,
          publishers,
          chartsBuilt,
          lineItems: displayReports.length === 1 ? displayReports[0][1].lineItems : [],
          campaigns: rawData.displayReports.map((d) => {
            const overallData = d[1].overallData;
            const campaignInfo = d[1];
            return {
              name: campaignInfo.name,
              startDate: moment(campaignInfo.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
              endDate: moment(campaignInfo.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
              budget: campaignInfo.budget,
              impressions: (overallData && overallData.impressions) || 0,
              clicks: (overallData && overallData.clicks) || 0,
              ctr: (overallData && overallData.ctr) || 0,
            };
          }),
          videoLogs: providerAll && providerAll.videoLogs,
          segments: providerAll && providerAll.segments,
        };
        data =
          providerIndex === 'All'
            ? all
            : displayReports && displayReports[parseInt(providerIndex)][1];
      } else {
        displayReports = rawData;
        all = rawData[0][1];
        data =
          providerIndex === 'All'
            ? rawData[0][1]
            : providersTab && providersTab[parseInt(providerIndex)][1];
      }
      setChartData({
        byDate: data.byDate || [],
        byDay: data.byDay || [],
        publishers: data.publishers || [],
        creatives: data.creatives || [],
        deviceType: data.deviceType || [],
        displayReports,
        chartsBuilt: data.chartsBuilt,
        videoLogs: data.videoLogs || [],
        segments: data.segments || [],
        lineItems: data.lineItems || [],
        campaigns:
          providerIndex === 'All' && rawData.displayReports.length > 1 // Only show campaigns if there are multiple providers
            ? all.campaigns
            : [],
        byProvider,
        ...chartData,
      });
    } else if (campaignOrder.version < 1.3 && chartData && chartData.byDate) {
      // setRawData(chartData);
      setLoadingRawData(false);
    }
  }, [
    rawData,
    setChartData,
    chartData,
    campaignOrder.version,
    providerIndex,
    byProvider,
    providersTab,
  ]);

  useEffect(() => {
    if (rawData) {
      let all, data, displayReports;
      if (rawData.displayReports) {
        const { byProvider, byDate, byDay, creatives, deviceType, publishers, chartsBuilt } =
          rawData;
        displayReports = rawData.displayReports;
        const providerAll = !isEmpty(byProvider) ? Object.entries(byProvider)[0][1] : null;
        all = {
          byDate,
          byDay,
          creatives,
          deviceType,
          publishers,
          chartsBuilt,
          lineItems: displayReports.length === 1 ? displayReports[0][1].lineItems : [],
          campaigns: rawData.displayReports.map((d) => {
            const overallData = d[1].overallData;
            const campaignInfo = d[1];
            return {
              name: campaignInfo.name,
              startDate: moment(campaignInfo.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
              endDate: moment(campaignInfo.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
              budget: campaignInfo.budget,
              impressions: (overallData && overallData.impressions) || 0,
              clicks: (overallData && overallData.clicks) || 0,
              ctr: (overallData && overallData.ctr) || 0,
            };
          }),
          videoLogs: providerAll && providerAll.videoLogs,
          segments: collectSegmentsFromProviders(displayReports),
        };
        data =
          providerIndex === 'All'
            ? all
            : displayReports && displayReports[parseInt(providerIndex)][1];
      } else {
        all = rawData[0][1];
        displayReports = rawData;
        data =
          providerIndex === 'All'
            ? rawData[0][1]
            : providersTab && providersTab[parseInt(providerIndex)][1];
      }
      setDisplayData({
        byDate: data.byDate || [],
        byDay: data.byDay || [],
        publishers: data.publishers || [],
        creatives: data.creatives || [],
        deviceType: data.deviceType || [],
        videoLogs: all.videoLogs || [],
        segments: data.segments || [],
        chartsBuilt: data.chartsBuilt,
        lineItems: data.lineItems || [],
        campaigns:
          providerIndex === 'All' && rawData.displayReports.length > 1 ? all.campaigns : [],
        displayReports,
        byProvider,
      });
      setLoadingRawData(false);
    }
  }, [byProvider, providerIndex, providersTab, rawData]);

  useEffect(() => {
    if (displayData && displayData.byDate && displayData.byDate.length) {
      const startByDate = displayData.byDate[0].xAxis;
      const endByDate = displayData.byDate[displayData.byDate.length - 1].xAxis;

      // UTC-anchor the seeded default range so it matches the Summary tab's
      // computation. `byDate.xAxis` buckets are UTC-midnight unix timestamps;
      // seeding via local-tz `moment.unix()`/`moment()` shifted the whole
      // range -1 day for west-of-UTC (e.g. PST) viewers, dropping the last
      // bucket from the KPI sum. Forcing UTC keeps the day boundaries identical
      // to Summary's `cleanFormatByDateReport(_, 'UTC')` (tz-invariant KPIs).
      const start = !isEmpty(displayData.byDate)
        ? isUnixTimestamp(startByDate)
          ? moment.unix(startByDate).utc()
          : moment.utc(startByDate)
        : null;
      const end = !isEmpty(displayData.byDate)
        ? isUnixTimestamp(endByDate)
          ? moment.unix(endByDate).utc()
          : moment.utc(endByDate)
        : null;

      // set the date range on the selected date in calendar
      setByCampaignRangeDate([start, end]);
      // set the data into filtered ones with the selected range dates
      setDataCampaignRangeDate(displayData.byDate);
    }
  }, [displayData, setByCampaignRangeDate, setDataCampaignRangeDate]);

  if (isValidUrl === true || (campaignOrder.version < 1.3 && chartData)) {
    return React.cloneElement(children, {
      chartData: campaignOrder.version < 1.3 ? chartData : displayData,
      chartsLoading: loadingRawData,
      isValidUrl,
      byCampaignRangeDate,
      setByCampaignRangeDate,
      dataCampaignRangeDate,
      setDataCampaignRangeDate,
      // `providerIndex` is destructured out of this component's props (line 18),
      // so it is NOT in `...props` — `props.providerIndex` was always undefined.
      // OverviewTab needs the real value to slice creativesWithDates /
      // publishersWithDates per provider (#11679 follow-up).
      providerIndex,
      hasInsights,
      selectedSegmentsDimension,
      userPermission: permission,
      setSegmentsDimension,
      displayReportsConnection,
      handleSelectPastReport,
      handleAfterChangePastReport,
      currentReportId,
      pastReportIdx,
      usePastReportId,
      handleUseDefaultReportId,
    });
  } else {
    return React.cloneElement(children, {
      chartData: null,
      isValidUrl,
      byCampaignRangeDate,
      setByCampaignRangeDate,
      dataCampaignRangeDate,
      setDataCampaignRangeDate,
      providersIndex: props.providersIndex,
      selectedSegmentsDimension,
      userPermission: permission,
      setSegmentsDimension,
      displayReportsConnection,
      handleAfterChangePastReport,
      handleSelectPastReport,
      currentReportId,
    });
  }
};

export default DisplayTabChartsController;
